<template>
  <div class="footre" :style="{ 'padding-top': styleTop }">
    <div class="footre_item">
      <p class="footre_item_logo">董车科技网络货运平台欢迎您的加入！</p>
      <div class="footre_item_info">
        <p class="footre_item_info_title">董车科技网络货运平台</p>
        <div class="footre_item_info_span">
          <span>帮助中心</span>
          <el-divider direction="vertical"></el-divider>
          <!-- <router-link to="userGuide"> -->
          <span class="span2" @click="linkClick('userGuide')">用户指南</span>
          <!-- </router-link> -->
        </div>
        <div class="footre_item_info_span">
          <span>关于我们</span>
          <el-divider direction="vertical"></el-divider>
          <!-- <router-link to="contactUs"> -->
          <span class="span2" @click="linkClick('contactUs')">联系我们</span>
          <!-- </router-link> -->
        </div>
        <div class="footre_item_info_span">
          <span>服务热线</span>
          <el-divider direction="vertical"></el-divider>
          <span class="span2">16638175323</span>
        </div>
      </div>
    </div>
    <div class="footre_bottom">
      <p>
        <!-- <i class="el-icon-user-solid"></i> -->
        <!-- <img src="data:image/png;base64,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" alt=""> -->
        <!-- <span class="cursor">豫公网安备：41080039010-21001号</span> -->
        <!-- <span>增值电信业务经营许可证：</span> -->
        <!-- <span class="cursor">豫B2-20210727</span> -->
      </p>
      <a
        href="https://xyt.xcc.cn/getpcInfo?sn=1838548100885458944&language=CN&certType=8&url=www.dongche56.com"
        target="_blank"
        style="
          position: relative;
          display: inline-block;
          width: 100%;
          height: 38px;
        "
      >
        <div
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        ></div>
        <embed
          src="https://web.dongche56.com/platformrules/www.dongche56.com.svg"
          width="103"
          height="38"
          type="image/svg+xml"
          pluginspage="//www.adobe.com/svg/viewer/install/"
        />
      </a>
      <p>
        <span>©2020 Copyright 2020-2021</span>
        <span class="cursor">董车科技网络货运平台</span>
        <span>All Rights Reserved. </span>
        <span class="cursor">豫ICP备2021024897号-1</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    styleTop: {
      type: String,
      default: "20px",
    },
  },
  methods: {
    linkClick(path) {
      console.log(this.$router, path);
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.footre {
  width: 100%;
  height: 100%;
  // padding-top: 50px;
  background: #242b36;
  .footre_item {
    background: #242b36;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    .footre_item_logo {
      font-size: 40px;
      color: #065fc3;
      font-style: italic;
    }
    .footre_item_info {
      margin-left: 90px;
      .footre_item_info_title {
        // margin-top: 25px;
        font-size: 22px;
        margin-bottom: 30px;
        color: #fff;
      }
      .footre_item_info_span {
        font-size: 16px;
        color: #b4c1cd;
        margin-bottom: 20px;
        .span2 {
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .footre_bottom {
    border-top: 1px solid #3f4955;
    background: #242b36;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    img {
      width: 18px;
    }
    span {
      color: rgb(180, 193, 205);
      margin: 0 4px;
      font-size: 14px;
    }
    .cursor {
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
